import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../config";
import { ILanguage } from "../Pages/types";

const LanguageSwitcher = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { i18n } = useTranslation();
  const { applicationLanguageListData } = useLanguage();
  const [applicationLanguage, setApplicationLanguage] = useState<ILanguage>({
    LanguageId: 0,
  });

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lang: string, languageId: number) => {
    const newLanguage = { ...applicationLanguage, LanguageId: languageId };
    const base64ApplicationLanguage = btoa(JSON.stringify(newLanguage));
    localStorage.setItem("language", base64ApplicationLanguage);
    localStorage.setItem("languageCode", lang);
    setApplicationLanguage(newLanguage);
    i18n.changeLanguage(lang);
    handleMenuClose();
  };

  return (
    <div>
      <IconButton edge="end" color="inherit" onClick={handleMenuOpen}>
        <LanguageIcon className="lg:text-3xl text-primary" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {applicationLanguageListData
          .sort((a, b) => a.applicationLanguageId - b.applicationLanguageId)
          .map((applicationLanguage) => (
            <>
              <MenuItem
                onClick={() => {
                  var languageId =
                    applicationLanguage?.applicationLanguageId || 0;
                  changeLanguage(
                    applicationLanguage?.languageCode || "",
                    languageId
                  );
                }}
              >
                {i18n.t(applicationLanguage?.languageName)}
              </MenuItem>
            </>
          ))}
      </Menu>
    </div>
  );
};
export default LanguageSwitcher;
